import { useEffect } from "react";

export function ImagePreloader({ imageUrls = [] }) {
  useEffect(() => {
    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
    });
  }, [imageUrls]);

  return (
    <div style={{ display: "none" }}>
      {imageUrls.map((url) => (
        <img key={url} src={url} alt="preload" />
      ))}
    </div>
  );
}
